<template>
  <el-drawer
    v-model="drawer.show"
    direction="btt"
    size="70%"
    custom-class="payment-details-drawer"
    :show-close="false"
  >
    <template #header>
      <div class="title">
        <h4>付款明细</h4>
        <div @click="copyDetails"><ab-svg name="my-fuzhi" class="issue"></ab-svg>复制</div>
      </div>
      <button
        aria-label="el.drawer.close"
        class="el-drawer__close-btn"
        type="button"
        style="color:#B2B2B2"
        @click="closeDrawer"
      >
        <i class="el-icon el-drawer__close">
          <el-icon :size="size" :color="color" >
            <CircleCloseFilled />
          </el-icon>
        </i>
      </button>
    </template>

    <template #default>
      <div class="paymentDetails">
        <div class="left">
          <h4>货款</h4>
          <ul>
            <li>
              <span>申请金额（{{ drawer.data.applyCurrencyCode }}）</span>
              <div class="number">{{ drawer.data.applyAmount }}</div>
            </li>
            <li>
              <span>结算汇率</span>
              <div class="number">{{ drawer.data.settleRate }}</div>
            </li>
            <li>
              <span>手续费（CNY）</span>
              <div class="number">{{ drawer.data.chargesBearerCny }}</div>
            </li>
          </ul>
        </div>
        <div class="right">合计（CNY）：<span class="number">{{ drawer.data.goodsTotalAmount }}</span></div>
      </div>

      <el-divider style="border-top: 1px solid #f0f2f5; margin: 35px 0" />

      <template v-if="billType !== 1 && !drawer.data.isPayFee">
        <div class="serviceDetails" v-if="drawer.data.feeList && drawer.data.feeList.length">
          <div class="left">
            <h4>服务费</h4>
            <ul>
              <li>
                <span>订单金额（{{ drawer.data.applyCurrencyCode }}）</span>
                <div class="number">{{ drawer.data.billAmount }}</div>
              </li>
              <li>
                <span>海关汇率</span>
                <div class="number">{{ drawer.data.customsRate }}</div>
              </li>
              <li>
                <span>服务费率</span>
                <div class="number">{{ drawer.data.serviceRate }}</div>
              </li>
            </ul>
          </div>

          <div class="right">
            <ul>
              <li
                v-for="(item, index) in drawer.data.feeList"
                :key="index"
              >
                <span>{{ item.feeName }}</span>
                <div class="number"><span v-if="typeof item.isPositive == 'boolean' && !item.isPositive"> - </span>{{ item.feeAmount }}</div>
              </li>
            </ul>
            <div class="rightMoney">合计（CNY）：<span class="number">{{ drawer.data.feeTotalAmount }}</span></div>
          </div>
        </div>
        <div class="serviceDetails-1" v-else>
            <h4>服务费</h4>
            <div class="banner">
                <div>费用明细计算中，出结果将通过微信消息通知您，请稍后！<img src=@/assets/img/yixiu-gb3.png alt=""></div>
                <img src="../../assets/img/qc.png" alt="">
                <p>关注服务号掌握动态</p>
            </div>
        </div>

        <el-divider style="border-top: 1px solid #f0f2f5; margin: 35px 0" />
      </template>

      <div class="goodsMoney" v-if="!drawer.data.isPayFee">
        <h4>货费合计（CNY）</h4>
        <div class="number">{{ drawer.data.totalAmount }}</div>
      </div>

      <el-alert v-if="drawer.data.remark1 && !drawer.data.isPayFee" :title="drawer.data.remark1" type="warning"></el-alert>
      <el-divider style="border-top: 1px solid #f0f2f5; margin: 35px 0" />

      <div class="collection">
        <div class="title">
          <h4>收款账号</h4>
          <div @click="copyAccount"><ab-svg name="my-fuzhi" class="issue"></ab-svg>复制</div>
        </div>
        <div class="banner">
          <ul class="left">
            <li>
              <span>公司名称</span>
              <div>{{ drawer.data.zxCompanyName }}</div>
            </li>
            <li>
              <span>开户银行</span>
              <div>{{ drawer.data.zxName }}</div>
            </li>
          </ul>
          <ul class="right">
            <li>
              <span>银行账号</span>
              <div class="number">{{ drawer.data.zxAccountNumber }}</div>
            </li>
            <li>
              <span>银行联行号</span>
              <div class="number">{{ drawer.data.zxBankCode }}</div>
            </li>
          </ul>
        </div>
      </div>

      <el-divider style="border-top: 1px solid #f0f2f5; margin: 50px 0 0" />

      <textarea class="copy-text" id="copyText"></textarea>
    </template>

    <template #footer>
      <div style="flex: auto">
        <el-button @click="closeDrawer">取消</el-button>
        <el-button type="primary" @click="toPay">去付款</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
export default {
  name: 'payment-details-drawer', // 付款明细弹框

  props: {

  },

  data () {
    return {
      billType: '',
      drawer: {
        show: false,
        data: {}
      }    
    }
  },

  watch: {

  },

  computed: {
    
  },

  methods: {
    init(id, billType) {
      this.billType = billType
      this.$post('/sms/client/paymentApp/queryFeesTotal', { id }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          if (data.result.clientStatus && !['01', '02-1'].includes(data.result.clientStatus)) {
            this.$emit('submited')
            this.drawer.data = data.result
            this.drawer.show = true
          }
        }
      })
    },

    closeDrawer() {
      this.drawer.data = {}
      this.drawer.show = false
      this.$emit('close')
    },

    toPay() {
      this.$router.push('/payable-list')
      this.closeDrawer()
    },

    copyDetails() {
      const input = document.getElementById('copyText')  // 找到虚拟的输入框
      let infoText = '货款\n' +
      '申请金额（' + (this.drawer.data.applyCurrencyCode || '') + '）：' + (this.drawer.data.applyAmount || '') + '\n' +
      '结算汇率：' + (this.drawer.data.settleRate || '') + '\n' +
      '手续费（CNY）：' + (this.drawer.data.chargesBearerCny || '') + '\n' +
      '合计（CNY）：' + (this.drawer.data.goodsTotalAmount || '') + '\n'
      if (this.drawer.data.feeList && this.drawer.data.feeList.length) {
        infoText += '服务费\n' +
        '订单金额（' + (this.drawer.data.applyCurrencyCode || '') + '）：' + (this.drawer.data.billAmount || '') + '\n' +
        '海关汇率：' + (this.drawer.data.customsRate || '') + '\n' +
        '服务费率：' + (this.drawer.data.serviceRate || '') + '\n'
        this.drawer.data.feeList.forEach(row => {
          infoText += `${row.feeName}：${row.feeAmount || ''}\n`
        })
        infoText += `合计（CNY）：${this.drawer.data.feeTotalAmount || ''}\n`
      }
      infoText += `货费合计（CNY）：${this.drawer.data.totalAmount|| ''}`
      input.value = infoText
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$message({
        type: 'success',
        message: '复制成功!',
        offset: 380,
        grouping: true
      })
    },

    copyAccount() {
      const input = document.getElementById('copyText')  // 找到虚拟的输入框
      input.value = '公司名称：' + (this.drawer.data.zxCompanyName || '') + '\n' +
      '开户银行：' + (this.drawer.data.zxName || '') + '\n' +
      '银行账号：' + (this.drawer.data.zxAccountNumber || '') + '\n' +
      '银行联行号：' + (this.drawer.data.zxBankCode || '')
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$message({
        type: 'success',
        message: '复制成功!',
        offset: 380,
        grouping: true
      })
    }
  }
}
</script>

<style lang="scss">
.payment-details-drawer {
  text-align: left;
  color: #000000;
  border-radius: 16px;
  .el-drawer__header {
    font-size: 18px;
    color: #000000;
    /*  width: 70%;
    margin: 0 auto; */
    //   width: 100%;
    width: 100%;
    padding: 20px 15% 0 15%;
    .title {
      display: flex;
      justify-content: space-between;
      h4 {
        font-size: 18px;
      }
      div {
        cursor: pointer;
        margin-right: 40px;
        font-size: 16px;
        .icon-svg {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 6px;
        }
      }
    }
  }
  .el-drawer__body {
    width: 100%;
    padding: 20px 15% 0 15%;
    padding-bottom: 0;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: #aaa;
      &:hover {
          background: #999;
      }
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    .el-alert {
      background-color: #feeae3;
      color: #f87243;
      margin-top: 30px;
      span {
        font-size: 14px;
      }
    }
    .paymentDetails {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      .left {
        width: 50%;
        display: flex;
        h4 {
          font-size: 16px;
          width: 100px;
        }
        li {
          font-size: 14px;
          margin-bottom: 15px;
          span {
            display: inline-block;
            width: 125px;
          }
          div {
            display: inline-block;
            width: 100px;
            text-align: right;
            font-size: 18px;
            font-weight: 500;
          }
          &:last-child {
            margin: 0;
          }
        }
      }
      .right {
        width: 50%;
        font-size: 14px;
        padding: 43px 0 0 40px;
        span {
          font-size: 48px;
          color: #f87243;
          font-weight: 500;
          margin-left: 50px;
        }
      }
    }

    .serviceDetails {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      .left {
        width: 50%;
        display: flex;
        h4 {
          font-size: 16px;
          width: 100px;
        }
        li {
          font-size: 14px;
          margin-bottom: 15px;
          span {
            display: inline-block;
            width: 125px;
          }
          div {
            display: inline-block;
            width: 100px;
            text-align: right;
            font-size: 18px;
            font-weight: 500;
          }
        }
      }
      .right {
        width: 50%;
        padding-left: 40px;
        li {
          display: flex;
          font-size: 14px;
          margin-bottom: 15px;
          span {
            display: inline-block;
            width: 128px;
          }
          div {
            display: inline-block;
            width: 110px;
            text-align: right;
            font-size: 18px;
            font-weight: 500;
          }
          &:last-child {
            margin: 0;
          }
        }
        .rightMoney {
          font-size: 14px;
          span {
            font-weight: 500;
            color: #f87243;
            font-size: 48px;
            margin-left: 50px;
          }
        }
      }
    }
    .serviceDetails-1 {
      width: 1000px;
      margin: 0 auto;
      h4 {
        font-size: 16px;
        font-weight: 400;
      }
      .banner {
        text-align: center;
        img {
          width: 120px;
          height: 120px;
          vertical-align: middle;
        }
        div {
          font-weight: 400;
          color: #f87243;
          font-size: 16px;
          img {
            width: 68px;
            height: 68px;
          }
        }
        p {
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }

    .goodsMoney {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      h4,
      div {
        width: 50%;
      }
      h4 {
        font-size: 16px;
      }
      div {
        padding-left: 187px;
        font-size: 48px;
        font-weight: 500;
        color: #f87243;
      }
    }
    .collection {
      .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;
        h4 {
          font-size: 18px;
        }
        div {
          cursor: pointer;
          margin-right: 55px;
          font-size: 16px;
          .icon-svg {
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 6px;
          }
        }
      }
      .banner {
        width: 1000px;
        display: flex;
        margin: 0 auto;
        ul {
          width: 50%;
        }
        li {
          margin-bottom: 15px;
          span {
            display: inline-block;
            width: 100px;
            font-size: 16px;
          }
          div {
            display: inline-block;
            font-size: 18px;
            font-weight: 500;
          }
          &:last-child {
            margin: 0;
          }
        }
        .right {
          padding-left: 40px;
          div {
            font-weight: 500;
          }
        }
      }
    }
  }
  .el-drawer__footer {
    text-align: center;
  }
}
</style>
